import { Alert, Button, Card, Form, Input, Modal } from 'antd'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions as adminActions } from '../../../../store/reducers/admin.reducer'
import { actions as authActions } from '../../../../store/reducers/auth.reducer'
import { useForm } from 'antd/es/form/Form'
import { openNotificationWithIcon } from '../../../../utils/notification.helper'

const SetupOtpCard = ({ generateOtp, user, setOtpConfigured, verifyOtp }) => {
    const [setupOtpVisible, setSetupOtpVisible] = useState(false)
    const [otpState, setOtpState] = useState()
    const [generateOtpLoading, setGenerateOtpLoading] = useState(false)
    const [verifyOtpLoading, setVerifyOtpLoading] = useState(false)
    const [form] = useForm()

    const onSetupOtp = async () => {
        setGenerateOtpLoading(true)

        try {
            const generateOtpResponse = await generateOtp()

            setOtpState(generateOtpResponse.data)

            setSetupOtpVisible(true)
        } finally {
            setGenerateOtpLoading(false)
        }
    }

    const onCloseOtpSetupModal = () => {
        setSetupOtpVisible(false)
    }

    const onVerifyOtp = async () => {
        setVerifyOtpLoading(true)

        try {
            const formData = await form.validateFields()

            const verifyOtpResponse = await verifyOtp(formData)

            if (!verifyOtpResponse.data.valid) {
                openNotificationWithIcon('error', 'Wrong OTP!')

                return
            }

            openNotificationWithIcon('success', 'OTP is successfully set up!')

            setOtpConfigured(true)
            onCloseOtpSetupModal()
        } finally {
            setVerifyOtpLoading(false)
        }
    }

    return (
        <Card title='OTP' bordered={false} className='mb-32'>
            {!user.otp_configured ? (
                <Button type='primary' className='ml-auto' loading={generateOtpLoading} onClick={onSetupOtp}>
                    Setup OTP
                </Button>
            ) : (
                <Alert
                    message='OTP is set up!'
                    type='success'
                    showIcon
                    description='Contact support in case you want to revoke it.'
                />
            )}
            <Modal
                title={'Scan QR code below in Google Authenticator app and enter generated OTP.'}
                open={setupOtpVisible && otpState}
                onCancel={onCloseOtpSetupModal}
                footer={<></>}
            >
                <img style={{ width: '100%' }} src={`data:image/png;base64,${otpState?.qr_code}`} />

                <Form
                    form={form}
                    name='impersonate-form'
                    onFinish={onVerifyOtp}
                    layout='vertical'
                    requiredMark={false}
                    validateTrigger={['onBlur', 'onSubmit']}
                >
                    <Form.Item
                        label='OTP'
                        name='otp'
                        rules={[{ required: true, message: 'Please, input OTP', validateTrigger: 'blur' }]}
                    >
                        <Input.OTP style={{ width: '100%' }} type='number' />
                    </Form.Item>
                    <Form.Item>
                        <Button type='primary' htmlType='submit' block loading={verifyOtpLoading}>
                            Verify
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </Card>
    )
}

const mapState = ({ auth }) => {
    return {
        user: auth.user,
    }
}

const mapDispatch = dispatch => {
    return {
        generateOtp() {
            return dispatch(adminActions.generateOtp())
        },
        verifyOtp(data) {
            return dispatch(adminActions.verifyOtp(data))
        },
        setOtpConfigured(otpConfigured) {
            return dispatch(authActions.setOtpConfigured(otpConfigured))
        },
    }
}

export default connect(mapState, mapDispatch)(SetupOtpCard)
